import dayjs from "dayjs";

// Customer-facing duty states (wfc-server customerPortal.service.ts DUTY_STATE),
// shared by Today, Roster and the duty drawer.
export const DUTY_STATE_META = {
    missedClockIn: { label: "Missed clock-in", color: "#dc2626", bg: "#fef2f2", attention: true },
    noShow:        { label: "Pending",         color: "#b91c1c", bg: "#fef2f2", attention: true },
    unassigned:    { label: "Needs officer",   color: "#e8590c", bg: "#fff4ed", attention: true },
    onDuty:        { label: "On duty",         color: "#16a34a", bg: "#f0fdf4" },
    awaiting:      { label: "Awaiting clock-in", color: "#0091ae", bg: "#e5f5f8" },
    upcoming:      { label: "Upcoming",        color: "#516f90", bg: "#f5f8fa" },
    completed:     { label: "Completed",       color: "#126e7d", bg: "#e5f5f8" },
};

export const stateMeta = (state) => DUTY_STATE_META[state] || DUTY_STATE_META.upcoming;

// No named officer (agency-assigned, or not yet assigned): show the provider,
// same as the Schedules tab's getAssigneeName
export const officerName = (row) => {
    if (row?.officer) return row.officer;
    if (!row?.assigned && !row?.clockIn) return "Not yet assigned";
    try {
        const detail = JSON.parse(localStorage.getItem("customerDetail"));
        return detail?.tenantDetail?.legalname || "Assigned";
    } catch (e) {
        return "Assigned";
    }
};

export const timeRange = (start, end) => {
    const s = dayjs(start);
    const e = dayjs(end);
    if (!s.isValid()) return "";
    if (!e.isValid()) return s.format("HH:mm");
    return `${s.format("HH:mm")}–${e.format("HH:mm")}${e.isAfter(s, "day") ? " (+1)" : ""}`;
};

export const formatHours = (h) => {
    if (h === null || h === undefined) return "—";
    const total = Math.round(Number(h) * 60);
    const hours = Math.floor(total / 60);
    const mins = total % 60;
    return mins ? `${hours}h ${String(mins).padStart(2, "0")}m` : `${hours}h`;
};

export const sourceLabel = (row) => (row?.source === "mobileService" ? "Mobile patrol" : "Guarding");

// Roster / roster PDF "view by": one group per site or per officer, each with its
// duties and booked hours. Duties nobody is on yet sit in their own group, last.
export const ROSTER_GROUPINGS = [
    { key: "day", label: "Day" },
    { key: "site", label: "Site" },
    { key: "officer", label: "Officer" },
];

export const groupRows = (rows, by) => {
    const groups = new Map();
    rows.forEach((r) => {
        let key, label, unassigned = false;
        if (by === "site") {
            key = String(r.siteId);
            label = r.siteName || "Site";
        } else {
            label = officerName(r);
            unassigned = !r.officer && !r.assigned && !r.clockIn;
            key = unassigned ? "~unassigned" : `o:${label}`;
        }
        if (!groups.has(key)) groups.set(key, { key, label, unassigned, rows: [], hours: 0 });
        const g = groups.get(key);
        g.rows.push(r);
        g.hours += r.hours || 0;
    });
    return [...groups.values()].sort((a, b) => (a.unassigned - b.unassigned) || a.label.localeCompare(b.label));
};
